import InternalUser from 'modules/user-management/internal-user';

export default function InternalUserPage() {
  return <InternalUser />;
}
